import locales from 'constants/locales';

/**
 * Generate hreflang URLs based on the domain configuration
 * Separates DE domain (supports DE and EN) from CH domain (only DE-CH)
 */
export const getHreflangUrls = ({
  asPath,
  currentLocale,
}: {
  asPath: string;
  currentLocale: string;
}): { hreflang: string; href: string }[] => {
  const urls: { hreflang: string; href: string }[] = [];
  const isLive = process.env.IS_LIVE === 'true';
  const branchName = process.env.BRANCH_NAME ?? '';
  const isStaging = process.env.PD_ENV === 'staging' && branchName !== 'dev';

  const deDomain = isLive
    ? 'https://www.petsdeli.de'
    : `https://${branchName}${isStaging ? '-staging' : ''}.petsdeli.de`;

  const chDomain = isLive
    ? 'https://www.petsdeli.ch'
    : `https://${branchName}${isStaging ? '-staging' : ''}.petsdeli.ch`;

  // For DE domain (supports DE and EN)
  if (currentLocale === locales.DE || currentLocale === locales.EN) {
    urls.push({
      hreflang: 'de',
      href: `${deDomain}${asPath}`,
    });

    urls.push({
      hreflang: 'en',
      href: `${deDomain}/en${asPath}`,
    });

    urls.push({
      hreflang: 'x-default',
      href: `${deDomain}${asPath}`,
    });
  }

  // For CH domain (only DE-CH)
  if (currentLocale === locales.CH) {
    urls.push({
      hreflang: 'de-CH',
      href: `${chDomain}${asPath}`,
    });

    urls.push({
      hreflang: 'x-default',
      href: `${chDomain}${asPath}`,
    });
  }

  return urls;
};
